// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__3ao_k","notes":"Notes_notes__So9T4"};